import React from 'react';
import { MainLeaderBoard, NavigationHeader } from '../../Components';

const Leaderboard = () => {
    return (
        <>
            <NavigationHeader />
            <MainLeaderBoard />
        </>
    );
};

export default Leaderboard;
